// export const API_ROOT_URL= 'https://pre.web3messaging.online'
export const API_ROOT_URL = process.env.REACT_APP_API_BASE_URL




